import {
  Tooltip as MantineTooltip,
  TooltipProps as MantineTooltipProps,
} from "@mantine/core"
import { forwardRef, PropsWithChildren } from "react"

export type TooltipProps = PropsWithChildren<MantineTooltipProps>

const Tooltip = forwardRef<HTMLDivElement, TooltipProps>(
  ({ children, label, ...props }, ref) => {
    return (
      <MantineTooltip ref={ref} label={label} {...props}>
        {children}
      </MantineTooltip>
    )
  }
)

export { Tooltip }
